/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from "@irian-ro/abstract-resource";

export class RoutingSolutionItemViewModel extends JSONable {

  uuid: string | undefined = undefined;

  handoverOfferUuid: string | undefined = undefined;

  pickupCity: string | undefined = undefined;

  pickupTimezone: string | undefined = undefined;

  pickupTimeWindowStart: string | undefined = undefined;

  pickupTimeWindowEnd: string | undefined = undefined;

  deliveryCity: string | undefined = undefined;

  deliveryTimezone: string | undefined = undefined;

  deliveryTimeWindowStart: string | undefined = undefined;

  deliveryTimeWindowEnd: string | undefined = undefined;

  requestedDeliveryTimeWindowStart: string | undefined = undefined;

  requestedDeliveryTimeWindowEnd: string | undefined = undefined;

  requestedForDeliveryHandover: string | undefined = undefined;

  requestedPickupTimeWindowStart: string | undefined = undefined;

  requestedPickupTimeWindowEnd: string | undefined = undefined;

  requestedForPickupHandover: string | undefined = undefined;

}
